var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1151_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 30.6C24.0186 30.6 30.6 24.0186 30.6 15.9C30.6 7.78143 24.0186 1.20001 15.9 1.20001C7.78143 1.20001 1.20001 7.78143 1.20001 15.9C1.20001 24.0186 7.78143 30.6 15.9 30.6Z",
    stroke: "white",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 21.2C18.6 21.1 18.6 20.9 18.5 20.7C18.5 20.5 18.4 20.3 18.4 20.1C18.2 20.3 18 20.4 17.8 20.6C17.6 20.8 17.3 20.9 17.1 21C16.8 21.1 16.6 21.2 16.2 21.3C15.9 21.4 15.5 21.4 15.2 21.4C14.6 21.4 14.1 21.3 13.6 21.1C13.1 20.9 12.7 20.7 12.3 20.4C11.9 20.1 11.7 19.7 11.5 19.3C11.3 18.9 11.2 18.4 11.2 17.9C11.2 16.7 11.7 15.7 12.6 15.1C13.5 14.4 14.9 14.1 16.7 14.1H18.4V13.4C18.4 12.8 18.2 12.4 17.9 12.1C17.5 11.8 17 11.6 16.3 11.6C15.7 11.6 15.3 11.7 15 12C14.7 12.3 14.6 12.6 14.6 13H11.6C11.6 12.5 11.7 12 11.9 11.6C12.1 11.2 12.4 10.8 12.9 10.4C13.3 10.1 13.8 9.79999 14.4 9.59999C15 9.39999 15.7 9.29999 16.5 9.29999C17.2 9.29999 17.8 9.39999 18.4 9.59999C19 9.79999 19.5 9.99999 20 10.4C20.4 10.7 20.8 11.2 21 11.7C21.2 12.2 21.4 12.8 21.4 13.5V18.5C21.4 19.1 21.4 19.6 21.5 20C21.6 20.4 21.7 20.8 21.8 21V21.2H18.7ZM15.8 19.1C16.1 19.1 16.4 19.1 16.6 19C16.9 18.9 17.1 18.8 17.3 18.7C17.5 18.6 17.7 18.5 17.8 18.3C17.9 18.2 18.1 18 18.2 17.9V15.9H16.7C16.2 15.9 15.8 15.9 15.5 16C15.2 16.1 14.9 16.2 14.7 16.4C14.5 16.6 14.3 16.7 14.2 17C14.1 17.2 14.1 17.5 14.1 17.7C14.1 18.1 14.2 18.4 14.5 18.7C14.8 19 15.3 19.1 15.8 19.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1151_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8,
    height: 31.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.f6d90aa251e90f99565e569057f0dc6d.svg";
export { ForwardRef as ReactComponent };